<template>
  <div class="flex_div">
    <boxTitleMoudle class="safe" :left="'0px'" :title="'安全生产'">
      <!-- 重点设备 -->
      <div class="leftList">
        <div class="major_device" style="height: 100%">
          <section style="width: 100; height: 30%">
            <img class="title" src="./img/major_device.png" alt="" />
            <span class="f-right1">
              设备总数：
              <i class="num digital">{{ eqi_totalNum }}</i>
            </span>
          </section>
          <section class="status" style="width: 100%; height: 70%">
            <li style="float: right">
              <span class="watch">在线</span>
              <span class="finish">故障</span>
              <span class="apply">离线</span>
            </li>

            <div id="chart002" style="height: 100%; width: 100%"></div>
          </section>
        </div>
      </div>
      <!-- 安全巡查 -->
      <div class="leftList" style="height: 30%">
        <div class="safe_work">
          <div style="height: 25%">
            <img
              class="title"
              style="width: 94%; margin-left: 16px"
              src="./img/safe_work.png"
              alt=""
            />
            <span class="f-right1" style="margin-top: 16px">
              已解决：
              <i class="num digital">{{ myUnRecheckCount }}</i>
            </span>
            <span class="f-right1" style="margin-top: 16px">
              问题总数:
              <i class="num digital">{{ questionNum }}</i>
            </span>
          </div>

          <div class="chartData flex-between" style="height: 82%">
            <div style="height: 100%; width: 40%">
              <li class="tab">
                <span
                  :class="index == tabIndex ? 'active' : ''"
                  @click="changeTab(index)"
                  v-for="(item, index) in tabList"
                  :key="index"
                  >{{ item }}</span
                >
                <!-- <span class="active">质量</span><span>安全</span> -->
              </li>
              <div
                id="chart01"
                style="height: 70%; width: 100%; margin-top: 30px"
              ></div>
            </div>
            <div style="width: 57%; text-align: center">
              <li class="flex-bet">
                <span>巡查人</span>
                <span>巡查时间</span>
                <span>地点</span>
                <span>问题</span>
              </li>
              <div style="overflow: hidden; height: 80%">
                <div>
                  <textData :length="4" :textData="safeData">
                    <template v-slot:checkPersonName="slotProps">
                      <span
                        class="text-overflow"
                        style="flex: 1; height: 30px; line-height: 30px"
                      >
                        {{ slotProps.val }}
                      </span>
                    </template>
                    <template v-slot:checkTime="slotProps">
                      <span
                        :title="slotProps.val"
                        class="text-overflow"
                        style="flex: 1; height: 30px; line-height: 30px"
                      >
                        {{ slotProps.val }}
                      </span>
                    </template>
                    <template v-slot:position="slotProps">
                      <span
                        :title="slotProps.val"
                        class="text-overflow"
                        style="flex: 1; height: 30px; line-height: 30px"
                      >
                        {{ slotProps.val }}
                      </span>
                    </template>
                    <template v-slot:status="slotProps">
                      <span
                        class="text-overflow"
                        style="flex: 1; height: 30px; line-height: 30px"
                      >
                        {{
                          slotProps.val == "-1"
                            ? "已撤回"
                            : slotProps.val == "0"
                            ? "待整改"
                            : slotProps.val == "1"
                            ? "待复查"
                            : "已关闭"
                        }}
                      </span>
                    </template>
                  </textData>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 安全作业 -->
      <div class="leftList" style="height: 20%">
        <div class="working" style="height: 100%; overflow: hidden">
          <section style="height: 20%">
            <img class="title" src="./img/working.png" alt="" />
            <span class="f-right1 finish">已完成</span>
            <span class="f-right1 watch">待监管</span>
            <span class="f-right1 apply">申请总数</span>
          </section>
          <section style="height: 80%; overflow: hidden; margin-top: 40px">
            <div
              class="contBox"
              ref="chartScroll"
              @mouseenter="addEchartActive()"
              @mouseleave="removeEchartActive()"
              id="chart02"
              style="height: 100%; width: 100%"
            ></div>
          </section>
        </div>
      </div>
      <!-- 安全培训 -->
      <div class="leftList">
        <div class="traning" style="height: 100%">
          <section style="height: 30%">
            <img class="title" src="./img/traning.png" alt="" />
            <span class="f-right1">
              安全培训总次数:
              <i class="num digital">{{ safeTotalNum }}</i>
            </span>
            <!-- <span class="f-right1">
              应参训人数:
              <i class="num">{{ shouldNum }}</i>
            </span> -->
          </section>

          <div class="traningEachart" style="height: 60%; width: 100%">
            <div id="chart03" style="height: 80%; width: 40%"></div>
            <div style="width: 60%">
              <div class="flex_bet text-center">
                <div
                  v-for="(item, index) in safeEducationList"
                  :key="index"
                  style="
                    width: 23%;
                    background: rgba(63, 114, 186, 0.2);
                    padding: 4px 0px;
                    color: rgb(255, 255, 255);
                  "
                >
                  <p style="color: #fff">
                    <span class="digital">{{ item.total }}</span>
                    次
                  </p>
                  <p style="color: #93bbf3; font-size: 14px">
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </boxTitleMoudle>
  </div>
</template>

<script>
import "./css/home.scss";
import boxTitleMoudle from "@/components/BaseBoxTitleMoudle.vue";
import textData from "@/components/textData.vue";
export default {
  data() {
    return {
      eqiName: "塔吊1",
      tabList: ["质量", "安全"],
      // echartScorll:
      //   '<div ref="chartScroll" id="chart02" style="height: 150%; width: 100%"></div>',
      tabIndex: "0",
      eqiNum: "",
      totalNum: "",
      tower_data: {
        height: "98",
        before: "47",
        after: "98",
        weight: "260",
        power: "26",
        rotation: "53",
        shake: "16",
        drop: "67",
        wind: "6",
        vertical: "45",
        level: "45",
      },
      safeData: [], //安全巡查列表
      safeEducationList: [],
      timer: null,
      charts: null,
      eqi_totalNum: "5",
      questionNum: 0,
      myUnRecheckCount: 0,
      safeTotalNum: 0,
      // 计时器
      scrollTime: null,
      distance: 0,
      echartScrollDistance: 0,
      echartsScrollTime: null,
      scrollArrList: [],
      sliceArrData: [],
      ind: 0,
      scrollList: [],
    };
  },

  mounted() {
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.echartsScrollTime);
    });
  },

  components: {
    boxTitleMoudle,
    textData,
  },
  methods: {
    //图表滚动移入
    addEchartActive() {
      clearInterval(this.echartsScrollTime);
    },
    // 图表滚动移出
    removeEchartActive() {
      this.echartsScrollTime = setInterval(() => {
        this._changeChartData();
      }, 5000);
    },

    // 切换
    changeTab(index) {
      this.tabIndex = index;
      index == "0"
        ? this.qualityStatistics("质量")
        : this.safeStatistics("安全");
      index == "0" ? this.qualityRecord() : this.safeRecord();
    },
    //质安巡检-质量-列表
    qualityRecord() {
      this.$api.qualityRecord().then((res) => {
        if (res.code == "200") {
          let list = (res.data && res.data.records) || [];
          this.safeData = list.map((item) => {
            return {
              checkPersonName: item.checkPersonName,
              checkTime: item.checkTime,
              position: item.position,
              status: item.status,
            };
          });
          console.log(this.safeData);
        }
      });
    },
    // 安全巡查列表
    safeRecord() {
      this.$api.safeRecord().then((res) => {
        if (res.code == "200") {
          let list = (res.data && res.data.records) || [];
          this.safeData = list.map((item) => {
            return {
              checkPersonName: item.checkPersonName,
              checkTime: item.checkTime,
              position: item.position,
              status: item.status,
            };
          });
        }
      });
    },
    // 重点设备监控
    getGroupStatistical() {
      this.$api.getGroupStatistical().then((res) => {
        if (res.code == "200") {
          let list = res.data.list;
          let objArr = [
            {
              typeId: "1",
              name: "人脸闸机",
            },
            {
              typeId: "2",
              name: "车辆识别设备",
            },
            {
              typeId: "3",
              name: "环境监测设备",
            },
            {
              typeId: "4",
              name: "塔吊设备",
            },
          ];
          // 总数
          let arrTotal = [];
          // 在线
          let onlineNumber = {
            name: "在线",
            dataArr: [],
          };
          // 故障
          let faultNumber = {
            name: "故障",
            dataArr: [],
          };
          // 离线
          let offlineNumber = {
            name: "离线",
            dataArr: [],
          };
          list.forEach((item) => {
            objArr.forEach((v) => {
              if (item.typeId == v.typeId) {
                onlineNumber.dataArr.push(item.onlineNumber);
                faultNumber.dataArr.push(item.faultNumber);
                offlineNumber.dataArr.push(item.offlineNumber);
              }
            });
          });

          arrTotal.push(onlineNumber, faultNumber, offlineNumber);
          let colorList = ["#0092ff", "#FF564F", "#C9C9C9"];
          this.chart02("chart002", objArr, arrTotal, colorList);
          this.eqi_totalNum = res.data.totalNumber;
        }
      });
    },

    //质安巡检-安全数量汇总
    safeStatistics() {
      this.$api.safeStatistics().then((res) => {
        if (res.code == "200") {
          let arr = [
            res.data.closeCount,
            parseInt(res.data.myUnRecheckCount) + parseInt(res.data.closeCount),
            res.data.totalCount,
          ];
          this.chart01(arr);
        }
      });
    },
    // 安全数量
    safeStatisticsNum() {
      this.$api.safeStatistics().then((res) => {
        if (res.code == "200") {
          this.questionNum = this.questionNum + parseInt(res.data.totalCount);
          this.myUnRecheckCount =
            this.myUnRecheckCount +
            parseInt(res.data.myUnRecheckCount) +
            parseInt(res.data.closeCount);
        }
      });
    },
    //质量图表
    qualityStatistics() {
      this.$api.qualityStatistics().then((res) => {
        if (res.code == "200") {
          let arr = [
            res.data.closeCount,
            parseInt(res.data.myUnRecheckCount) + parseInt(res.data.closeCount),
            res.data.totalCount,
          ];
          this.chart01(arr);
        }
      });
    },
    // 质量数据
    qualityStatisticsNum() {
      this.$api.qualityStatistics().then((res) => {
        if (res.code == "200") {
          this.questionNum = 0 + parseInt(res.data.totalCount);
          this.myUnRecheckCount =
            0 +
            parseInt(res.data.myUnRecheckCount) +
            parseInt(res.data.closeCount);

          this.safeStatisticsNum();
        }
      });
    },
    // 安全作业
    safeJob() {
      this.$api.safeJob().then((res) => {
        if (res.code == "200") {
          let objArr = [];

          if (res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              let obj = {
                name: item.typeName,
                dataArr: [],
              };
              objArr.push(obj);
            });

            // 总数
            let arrTotal = [];
            // 申请总数
            let totalCount = {
              name: "申请总数",
              dataArr: [],
            };
            // 待监管
            let waitingCount = {
              name: "待监管",
              dataArr: [],
            };
            // 已完成
            let finishedCount = {
              name: "已完成",
              dataArr: [],
            };
            // let totalData = 0;
            // let finishedData = 0;
            res.data.forEach((item) => {
              objArr.forEach((v) => {
                if (item.typeName == v.name) {
                  totalCount.dataArr.push(item.totalCount);
                  // totalData += item.totalCount;
                  // finishedData += item.finishedCount;
                  waitingCount.dataArr.push(item.waitingCount);
                  finishedCount.dataArr.push(item.finishedCount);
                }
              });
            });

            arrTotal = [totalCount, waitingCount, finishedCount];
            // this.questionNum = totalData;
            // this.finshNum = finishedData;

            // this.chart02("chart02", objArr, arrTotal, colorlist);
            objArr.forEach((item, index) => {
              arrTotal.forEach((v) => {
                item.dataArr.push(v.dataArr[index]);
              });
            });
            this.scrollArrList = objArr;

            //  let sliceArrData = this._sliceArr(objArr, 4);

            // // this.chart02("chart02", objArr, colorlist);
            // this.scrollChart("chart02", sliceArrData[0]);
            this._changeChartData();
            this.echartsScrollTime = setInterval(() => {
              this._changeChartData();
            }, 5000);
          }
        }
      });
    },

    // 安全培训
    safeEducation() {
      this.$api.safeEducation().then((res) => {
        if (res.code == "200") {
          let education = res.data.education;
          let educationPei = [
            {
              name: "班前教育天数",
              value: education.num,
            },
            {
              name: "安全施工天数",
              value: education.safeWorkDays,
            },
          ];
          this.chart03(educationPei);
          if (res.data.list && res.data.list.length > 0) {
            let num = 0;
            res.data.list.forEach((item) => {
              num += item.total;
            });
            this.safeTotalNum = num;
            this.safeEducationList = res.data.list;
          }
        }
      });
    },
    chart01(data) {
      let this_ = this;

      let myChart = this_.$echarts.init(document.getElementById("chart01"));
      let option = {
        color: ["#0BAFC2", "#0F5092", "#0693B9", "#0F5092"],
        tooltip: {
          trigger: "item",
          formatter: function(arg) {
            let shu = ((data[1] / data[2]) * 100).toFixed(2);
            if (isNaN(shu)) {
              shu = 0;
            }
            let html = arg.seriesName + "</br>";
            html += "整改率:" + shu + "%</br>";

            html += "验收率:" + shu + "%</br>";
            console.log(arg);
            return html;
          },
        },

        series: [
          {
            name: "质安巡查",
            type: "funnel",

            left: "10%",
            top: 0,
            right: "20%",
            //x2: 80,
            bottom: 0,
            width: "85%",
            // height: {totalHeight} - y - y2,
            min: 0,
            max: 70,
            minSize: "0%",
            maxSize: "100%",
            sort: "descending",
            gap: 0,
            label: {
              show: true,
              position: "inside",
            },
            // labelLine: {
            //   length: 10,
            //   lineStyle: {
            //     width: 1,
            //     type: "solid",
            //   },
            // },
            itemStyle: {
              borderColor: "#000712",
              borderWidth: 0,
            },
            emphasis: {
              label: {
                fontSize: 10,
              },
            },
            data: [
              { value: 50, name: "验收完成数" + data[0] },
              { value: 60, name: "问题处理数" + data[1] },
              { value: 70, name: "隐患发现数" + data[2] },
              {
                value: 40,
                name: "订单111",
                itemStyle: {
                  opacity: 0,
                },
                label: {
                  show: false,
                },
                tooltip: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    _changeChartData() {
      this.sliceArrData = this._sliceArr(this.scrollArrList, 4);

      let list = [...this.sliceArrData];
      if (this.ind >= list.length) {
        this.ind = 0;
      }
      this.scrollList = list[this.ind];
      this.scrollChart("chart02", this.scrollList);
      this.ind++;
    },
    // 滚动图表
    scrollChart(id, data) {
      let this_ = this;
      let colorlist = ["#c9c9c9", "#529aff", "#30cc31"];
      let myChart = this_.$echarts.init(document.getElementById(id));


      let nameList = [];
      if (typeof(data)!==undefined&&data) {
        data.forEach((item) => {
          nameList.push(item.name);
        }); 
      }

      let list = [
        {
          name: "申请总数",
          dataArr: [],
        },
        {
          name: "待监管",
          dataArr: [],
        },
        {
          name: "已完成",
          dataArr: [],
        },
      ];
      if(typeof(data)!==undefined&&data){
         data.forEach((item) => {
        item.dataArr.forEach((v, ind) => {
          list[ind].dataArr.push(v);
        });
      });
      }
     

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },

          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          },
          formatter: function(params) {
            let html = "<p>" + params[0].name + "</p>";
            var arr = [];
            params.forEach((item) => {
              // html += "<span>" + item.seriesName + ":" + item.value + "</span>";
              arr.push(item.seriesName + ":" + item.value);
            });
            html += arr.join(" ");
            return html;
          },
        },
        color: colorlist,
        grid: {
          left: "8%",
          right: "4%",
          bottom: "10%",
          top: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            show: true,
            color: "#fff",
            interval: 0,
          },
          data: nameList,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        series: (function() {
          let arr = [];
          list.forEach((item) => {
            let seriesData = {
              name: item.name,
              type: "bar",
              stack: "总量",
              barWidth: "15",
              label: {
                show: false,
                position: "insideRight",
              },
              data: item.dataArr,
            };

            arr.push(seriesData);
          });
          return arr;
        })(),
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // name,data,colorlist
    chart02(id, name, data, colorlist) {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById(id));
      let nameList = [];
      name.forEach((item) => {
        nameList.push(item.name);
      });
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },

          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          },
          formatter: function(params) {
            let html = "<p>" + params[0].name + "</p>";
            var arr = [];
            params.forEach((item) => {
              // html += "<span>" + item.seriesName + ":" + item.value + "</span>";
              arr.push(item.seriesName + ":" + item.value);
            });
            html += arr.join(" ");
            return html;
          },
        },
        color: colorlist,
        grid: {
          left: "8%",
          right: "4%",
          bottom: "10%",
          top: id == "chart02" ? "1%" : "20%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            show: true,
            color: "#fff",
            interval: 0,
          },
          data: nameList,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        series: (function() {
          let arr = [];
          data.forEach((item) => {
            let seriesData = {
              name: item.name,
              type: "bar",
              stack: "总量",
              barWidth: "65%",
              label: {
                show: false,
                position: "insideRight",
              },
              data: item.dataArr,
            };

            arr.push(seriesData);
          });
          return arr;
        })(),
        // [
        //   {
        //     name: "其他",
        //     type: "bar",
        //     stack: "总量",
        //     barWidth: "70%",
        //     label: {
        //       show: true,
        //       position: "insideRight",
        //     },
        //     data: [80, 90, 100],
        //   },
        //   {
        //     name: "临时用电",
        //     type: "bar",
        //     stack: "总量",
        //     barWidth: "70%",
        //     label: {
        //       show: true,
        //       position: "insideRight",
        //     },
        //     data: [70, 12, 120],
        //   },
        //   {
        //     name: "动火申请",
        //     type: "bar",
        //     stack: "总量",
        //     barWidth: "70%",
        //     label: {
        //       show: true,
        //       position: "insideRight",
        //     },
        //     data: [87, 10, 300],
        //   },
        // ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    chart03(educationPei) {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart03"));

      // let total = 0;
      // educationPei.forEach((item) => {
      //   total += item.value;
      // });

      let per = ((educationPei[0].value / educationPei[1].value) * 100).toFixed(
        2
      );
      console.log(educationPei, per, "perper");
      let process = [
        { name: "班前教育", value: per },
        { name: "总进度", value: 100 },
      ];

      let option = {
        tooltip: {
          trigger: "item",
          formatter: function(arg) {
            console.log(arg, "s");
            var html = "完成度:" + per + "%</br>";
            educationPei.forEach((item) => {
              html += item.name + ":" + item.value + "天</br>";
            });
            return html;
          },
        },
        color: ["#27D9C8", "#D8D8D8", "yellow"],
        // title: {
        //   text: "一级",
        //   left: "center",
        //   top: "52%",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: 14,
        //     align: "center",
        //   },
        // },
        graphic: {
          type: "text",
          left: "center",
          top: "50%",
          style: {
            text: "班前教育",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            //fontWeight: 500,
          },
        },
        series: [
          {
            name: "班前教育",
            type: "pie",
            radius: ["75%", "85%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            labelLine: {
              normal: {
                length: 0.1,
              },
            },
            // label: {
            //   normal: {
            //     show: false,
            //     position: "center",
            //   },
            // },
            label: {
              normal: {
                show: false,
                // formatter: function (params) {
                //   console.log(params,'params')
                //   return "重写label";
                // },

                // textStyle: {
                // 	fontSize: this.standSize / 150,
                // 	color: "#fff"
                // },
              },
            },

            // itemStyle: {
            //   borderWidth: 5, //设置border的宽度有多大
            //   borderColor: "#fff",
            // },

            data: process,
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },

    // 分割数组
    _sliceArr(arr, len) {
      let newArr = []; //首先创建一个新的空数组。用来存放分割好的数组
      for (let i = 0; i < arr.length; ) {
        //注意：这里与for循环不太一样的是，没有i++
        newArr.push(arr.slice(i, (i += len)));
      }
      return newArr;
    },
  },
  created() {
    //安全巡查——质量数量
    this.qualityStatisticsNum();

    //安全巡查——安全数量
    // this.safeStatisticsNum();

    // 重点设备监控
    this.getGroupStatistical();
    // 安全巡查列表
    // this.safeRecord();
    // 质安巡检-安全数量汇总
    // this.safeStatistics();
    // 安全作业
    this.safeJob();
    // 安全培训
    this.safeEducation();
    // 质量列表
    this.qualityRecord();
    // 质量汇总
    this.qualityStatistics();
  },
};
</script>
<style lang="scss" scoped>
.contBox {
  // transition: all 0.5s ease-in-out;
  transition: all 0.5s linear;
  height: 100%;
}
.flex_div {
  width: 100%;
  height: 100%;
}
.safe {
  .leftList {
    height: 25%;
  }
}
.digital {
  font-family: digital;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
}
</style>
